import { theme } from '@/@mui';
import { ActivityStatus } from '@/data/idp/plans/interfaces';

const palette = theme.palette;

export const activityStatusColorMap = {
  [ActivityStatus.Completed]: {
    backgroundColor: palette.success.light,
    color: palette.success.dark,
  },
  [ActivityStatus.InProgress]: {
    backgroundColor: palette.info.light,
    color: palette.info.dark,
  },
  [ActivityStatus.Pending]: {
    backgroundColor: palette.status.todo,
    color: palette.neutral[700],
  },
};

export const activityStatusLabel = {
  [ActivityStatus.Pending]: 'Não iniciado',
  [ActivityStatus.InProgress]: 'Em andamento',
  [ActivityStatus.Completed]: 'Feito',
};
